/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleFileSearchResult } from './APIArticleFileSearchResult';
import {
    APIArticleFileSearchResultFromJSON,
    APIArticleFileSearchResultFromJSONTyped,
    APIArticleFileSearchResultToJSON,
} from './APIArticleFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIArticleFileSearchResponse
 */
export interface APIArticleFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIArticleFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIArticleFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIArticleFileSearchResult>}
     * @memberof APIArticleFileSearchResponse
     */
    results: Array<APIArticleFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIArticleFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIArticleFileSearchResponse interface.
 */
export function instanceOfAPIArticleFileSearchResponse(value: object): value is APIArticleFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIArticleFileSearchResponseFromJSON(json: any): APIArticleFileSearchResponse {
    return APIArticleFileSearchResponseFromJSONTyped(json, false);
}

export function APIArticleFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIArticleFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIArticleFileSearchResponseToJSON(value?: APIArticleFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIArticleFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

